import { Mail, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t } = useTranslation();

  return (
    <section id="contact" className="bg-[#F7FBFA] py-12 sm:py-20">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-2xl font-semibold text-[#006B5F] sm:text-4xl">
            {t("contact.title")}
          </h2>
          <p className="mt-3 text-base leading-7 text-[#4E6764] sm:text-xl">
            {t("contact.subtitle")}
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-xl rounded-[18px] border border-[#006B5F]/15 bg-white p-5 shadow-sm sm:mt-10 sm:rounded-[20px] sm:p-8">
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="rounded-xl bg-[#006B5F]/10 p-2">
                <Mail className="h-5 w-5 text-[#006B5F]" />
              </div>
              <div>
                <p className="text-base font-semibold text-[#355852] sm:text-lg">
                  {t("contact.info.email")}
                </p>
                <a
                  href="mailto:info@omsorgsterapi.dk"
                  className="break-all text-base text-[#006B5F] underline underline-offset-4 sm:text-lg"
                >
                  info@omsorgsterapi.dk
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="rounded-xl bg-[#006B5F]/10 p-2">
                <MapPin className="h-5 w-5 text-[#006B5F]" />
              </div>
              <div>
                <p className="text-base font-semibold text-[#355852] sm:text-lg">
                  {t("contact.info.location")}
                </p>
                <p className="text-base text-[#4E6764] sm:text-lg">{t("contact.info.country")}</p>
              </div>
            </div>

            <div className="border-t border-[#006B5F]/12 pt-6 text-left">
              <p className="font-semibold text-[#355852]">Omsorgsterapi.dk</p>
              <p className="mt-1 text-[#4E6764]">CVR: 45482278</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
